export function isProfileInactive(guideId, profiles) {
  const profile = profiles[guideId];

  if (profile) {
    return profile.isInactive;
  }

  return true;
}
